import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import 'hammerjs';
import { Circles } from 'react-loader-spinner';
import axios from '../common/axios';
import { Box,Typography } from '@mui/material';
import ProgressChartWithTitle from './common/schartwithTitle';
import dayjs from 'dayjs';
import MLineChartWithTitle from './common/multilinechartwithTitle';


const RoomPRDChart = ({ height, width,criteriaDate, selectedProject }) => {
    const [chartData, setChartData] = useState({});
    const [loading, setLoading] = useState(true);


    const totalArea = _.sumBy(chartData.week, "MD")  / _.sumBy(_.uniqBy(chartData.week, "room"), "Area") 

    console.log(totalArea)

    useEffect(() => {
      const fetchData = async () => {
        const date = criteriaDate.format('YYYY-MM-DD');
        try {
          if (selectedProject) {
            const response = await axios.get(`/getroomresource?project=${selectedProject}&date=${date}`);
            if (response.data.success) {

              setChartData({ week: response.data.filledWeekProgress, month: response.data.filledMonthProgress });
              setLoading(false);
            } else {
              setChartData({});
              setLoading(false);
            }
          }
        } catch (error) {
          setChartData({});
          setLoading(false);
          console.error(`데이터 가져오기 중 오류 발생:`, error);
          return []; // 오류 발생 시 빈 배열 반환
        }
      };
      fetchData();
    }, [criteriaDate, selectedProject]);
    
  
    if (loading) {
      return (
          <Box
              sx={{
                  display: 'flex',
                  justifyContent: 'center', // 수평 중앙 정렬
                  alignItems: 'center',     // 수직 중앙 정렬
                  height: '100%',           // 부모 컨테이너의 전체 높이 사용
              }}
          >
              <Circles ariaLabel="loading" color="#00BFFF" height={50} width={50} />
          </Box>
      );
  }

  return (
    
    <MLineChartWithTitle
        height={height}
        width={width}
        title="ROOM 평당 투입 공수"
        chartData={chartData}
        chart_id="roommd"
        totalArea={totalArea}
        // maxYaxis={110}
    />
);
  
};


export default RoomPRDChart

